import { Component, inject, OnInit } from '@angular/core'
import { Navbar } from '../../common/navbar/navbar.component'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { controlValueEqualValidator, passwordPatternValidator } from '../../../validators/validators'
import { AuthService } from '../../../services/auth.service'
import { commonUtil } from '../../../utils/common.util'

@Component({
  selector: 'app-account-setting',
  imports: [Navbar, ReactiveFormsModule, TranslateModule],
  templateUrl: './account-setting.component.html',
  styleUrl: './account-setting.component.css'
})
export class AccountSetting implements OnInit {
  private authService = inject(AuthService)
  private translateService = inject(TranslateService)
  formBuilder = inject(FormBuilder)
  userEmail?: string
  updatePwdForm = this.formBuilder.group({
    currentPassword: ['', [Validators.required]],
    newPassword: ['', [Validators.required, passwordPatternValidator()]],
    confirmPassword: ['', [Validators.required]]
  })
  isShowCurrentPwd = this.formBuilder.control(false)
  isShowNewPwd = this.formBuilder.control(false)
  isShowConfirmPwd = this.formBuilder.control(false)
  isPwdChanging = false

  onSubmit() {
    if (this.updatePwdForm.invalid) {
      this.updatePwdForm.markAllAsTouched()
      return
    }
    this.isPwdChanging = true
    let value = this.updatePwdForm.getRawValue()
    this.authService
      .changePassword(
        value.currentPassword!,
        value.newPassword!,
        value.confirmPassword!
      )
      .subscribe({
        next: (success) => {
          if (success) {
            commonUtil.alert(
              this.translateService.instant(
                'app.accountSetting.passwordUpdateSuccessfully'
              ),
              'success'
            )
          }
          this.isPwdChanging = false
        },
        error: () => (this.isPwdChanging = false)
      })
  }

  ngOnInit(): void {
    this.userEmail = this.authService.getCurrentUser()?.email
    let newPwdControl = this.updatePwdForm.get('newPassword')
    this.updatePwdForm
      .get('confirmPassword')
      ?.addValidators(controlValueEqualValidator(newPwdControl))
  }
}
